import { render, staticRenderFns } from "./u-pagination-elevated-circle.vue?vue&type=template&id=efe88c56&scoped=true"
import script from "./u-pagination-elevated-circle.vue?vue&type=script&lang=js"
export * from "./u-pagination-elevated-circle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe88c56",
  null
  
)

export default component.exports